import { getProperty } from '@/common/oldMobile';
import { makeBotDefence } from '@/botdefence/botDefenceInstance';

const fppBotDefence = makeBotDefence(getProperty('__b_d_A_E'));

export default fppBotDefence;
